import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const ExceptionalJobsConfiguration = () =>
  import(
    /* webpackChunkName: "ExceptionalJobsConfiguration" */
    '@/views/configuration/exceptionalJobs/ExceptionalJobs.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: '/configuration/exceptionalJobs',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'Exceptional Jobs'
};

export const ExceptionalJobsRoutes = [
  {
    ...Configuration.ExceptionalJobs.ExceptionalJobsConfiguration,
    components: {
      default: ExceptionalJobsConfiguration,
      treeView: ConfigurationTreeView
    },
    meta
  }
];
